import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AxiosError } from "axios";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import HelpAndSupportService from "../../../services/http/services/HelpAndSupportService";
import { ContactStatus, IContact } from "../interfaces";

export default function useViewHelpAndSupport() {
    const { id } = useParams();
    const [data, setData] = useState<IContact>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const type = searchParams.get('type');

    const isGeneral = useMemo(() => {
        return type?.toLowerCase() === "general";
    }, [type]);

    useEffect(() => {
        const controller = new AbortController();

        async function loadContact() {
            try {
                setIsLoading(true);
                const messageData = await HelpAndSupportService.getContactById(Number(id), controller.signal);

                setData(messageData);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                setIsLoading(false);

                EmitError(err, true, 'editMessage_opasdasjpdasd');

                navigate(`/ajuda-e-suporte/usuarios`);
            }
        }

        loadContact();

        return () => {
            controller.abort();
        }
    }, [id, navigate, isGeneral]);

    async function handleSubmitMessage(messageData: FormData) {
        const controller = new AbortController();
        try {
            await HelpAndSupportService.createMessageContact(messageData);

            //Atualizar a lista de mensagens
            setIsLoading(true);
            const data = await HelpAndSupportService.getContactById(Number(id), controller.signal);

            setData(data);
            setIsLoading(false);

            EmitSuccessAlert('Mensagem enviada para o usuário com sucesso!');
        } catch (err) {
            EmitError(err, true, 'editMessage_asiopdasodasd');
        }
    }

    async function handleStatusChange(status: ContactStatus) {
        const controller = new AbortController();
        try {
            await HelpAndSupportService.updateStatusContact(Number(id), status);

            setIsLoading(true);
            const data = await HelpAndSupportService.getContactById(Number(id), controller.signal);

            setData(data);
            setIsLoading(false);

            EmitSuccessAlert('Status alterado com sucesso!');
        } catch (err) {
            EmitError(err, true, 'changeStatusContact_asiopdasodasd');
        }
    }

    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

    const handleRefresh = async () => {
        const controller = new AbortController();
        try {
            setIsRefreshing(true);
            const messageData = await HelpAndSupportService.getContactById(Number(id), controller.signal);
            setData(messageData);
        } catch (err) {
            if (err instanceof AxiosError && err.name === 'CanceledError') {
                return;
            }
        } finally {
            setIsRefreshing(false);
        }
    };

    return {
        isLoading,
        isRefreshing,
        data,
        handleSubmitMessage,
        handleStatusChange,
        handleRefresh,
    };
}
